import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { ReclamationActionDetailCodes } from 'constants.js';

const styles = theme => ({
    formControl: {
        width: '100%'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});

class FacturerTransporteurDialogContent extends React.Component {

    state = {
        numeroPiece: '',
        numeroAvoir: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.numeroAvoir)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de pièce',
                position: 0,
                valeurString: newState.numeroPiece
            }, {
                code: ReclamationActionDetailCodes.Avoir,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro d\'avoir',
                position: 1,
                valeurString: newState.numeroAvoir
            }]
        };

        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { numeroAvoir, numeroPiece } = this.state;

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    id="numeroPiece"
                    name="numeroPiece"
                    label="Numéro de pièce (prépa ou BL)"
                    placeholder="Numéro de pièce"
                    multiline
                    margin="normal"
                    value={numeroPiece}
                    onChange={this.handleChange}
                />

                <TextField className={classes.formControl}
                    required
                    id="numeroAvoir"
                    name="numeroAvoir"
                    label="Numéro d'avoir"
                    placeholder="Numéro d'avoir"
                    multiline
                    margin="normal"
                    value={numeroAvoir}
                    onChange={this.handleChange}
                />
            </DialogContent>
        );
    }
}

FacturerTransporteurDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(FacturerTransporteurDialogContent);